import { render, staticRenderFns } from "./select_mygoods_list.vue?vue&type=template&id=95309936&scoped=true"
import script from "./select_mygoods_list.vue?vue&type=script&lang=js"
export * from "./select_mygoods_list.vue?vue&type=script&lang=js"
import style0 from "./select_mygoods_list.vue?vue&type=style&index=0&id=95309936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95309936",
  null
  
)

export default component.exports